import { render, staticRenderFns } from "./RoutineReminderModal.vue?vue&type=template&id=5344eb5a"
import script from "./RoutineReminderModal.vue?vue&type=script&lang=js"
export * from "./RoutineReminderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports